"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const utils_1 = require("@osmosys/utils");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const react_2 = require("@osmosys/react");
const EspAdapterRequest_1 = require("./EspAdapterRequest");
class AssetCategories extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            page: 0,
        };
    }
    render() {
        const { page } = this.state;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(EspAdapterRequest_1.EspAdapterRequest, { integration: this.props.integration, fn: "listAssetCategories", variables: {
                    data: JSON.stringify({
                        $page: page + 1,
                        $pagesize: 10,
                    }),
                } }, data => {
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(reactstrap_1.Row, null,
                        react_1.default.createElement(reactstrap_1.Col, null,
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Total count"),
                                " ",
                                data.count),
                            react_1.default.createElement("p", null,
                                react_1.default.createElement("strong", null, "Page size"),
                                " ",
                                data.pageSize),
                            react_1.default.createElement(react_2.OsmosysPagination, { pageCount: Math.ceil(data.count / data.pageSize), forcePage: data.page - 1, onPageChange: newPage => this.setState({
                                    page: newPage,
                                }) }),
                            react_1.default.createElement("hr", null),
                            data.items &&
                                data.items.map(item => {
                                    return (react_1.default.createElement(reactstrap_1.Card, { key: item.id, className: "mb-3", onClick: () => {
                                            utils_1.logger.info(item);
                                        } },
                                        item.name && (react_1.default.createElement(reactstrap_1.CardHeader, { tag: "h3" }, item.name)),
                                        react_1.default.createElement(reactstrap_1.CardBody, null, item.description && (react_1.default.createElement(reactstrap_1.CardText, { tag: "p", className: "lead" }, item.description))),
                                        react_1.default.createElement(reactstrap_1.CardFooter, { className: "text-muted" }, item.categoryType ? (react_1.default.createElement(react_1.default.Fragment, null, item.categoryType)) : ('No category type'))));
                                })))));
            })));
    }
}
exports.AssetCategories = AssetCategories;
//# sourceMappingURL=AssetCategories.js.map